import * as types from "../constants/ActionTypes";
import { INITIAL_STATE } from "../constants/AppConstants";

const modifyTicketDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.POST_TICKET_DATA_REQUEST:
      return Object.assign({}, state, action.value);
    default:
      return state;
  }
};

export default modifyTicketDataReducer;
